import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Link from './Link';

const propTypes = {
    url: PropTypes.object,
    box: PropTypes.bool,
    border: PropTypes.bool,
    rounded: PropTypes.bool,
    background: PropTypes.bool,
    ratio: PropTypes.number, // eslint-disable-line
    media: PropTypes.shape({
        url: PropTypes.string.isRequired,
    }),
};

const defaultProps = {
    src: null,
    url: null,
    box: true,
    border: true,
    rounded: true,
    background: false,
    ratio: 0.5625,
    media: {
        url: null,
    },
};

class Image extends Component {

    renderImage() {
        const { background, media, ratio } = this.props;
        const url = typeof media !== 'undefined' && media !== null ? media.url : null;
        const name = typeof media !== 'undefined' && media !== null ? media.name : null;

        const bgStyle = {
            backgroundImage: url && background ? `url(${url})` : null,
            paddingBottom: `${ratio * 100}%`,
        };

        return background !== null && background === true ? (
            <div style={bgStyle} className="image-background" />
        ) : (
            <img src={url} alt={name} />
        );
    }

    render() {
        const { url, box, rounded, border, background } = this.props;

        const className = classNames({
            image: true,
            partial: true,
            'partial-image': true,
            rounded,
            border,
            box,
            background: background !== null && background === true,
        });

        return (
            <div className={className}>
                { url !== null ? (
                    <Link to={url}>
                        { this.renderImage() }
                    </Link>
                ) : (
                    this.renderImage()
                ) }
            </div>
        );
    }
}

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

export default Image;



// WEBPACK FOOTER //
// ./components/partials/Image.jsx